
import { useNavigate } from "react-router-dom";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from "../../../common/ToastHandler";
import { ArrowRight, FileText } from "lucide-react";


const PrintReport = ({ shiftId }) => {
  const navigate = useNavigate();
  const { Post } = useApi();
  const { handleToast } = useToastHandler();

  const printDailyReport = async (shiftId) => {
    try {
      if (!shiftId) {
        console.error("No shift ID provided to printDailyReport");
        handleToast({
          type: "ERROR",
          message: "No shift ID provided to printDailyReport"
        });
        return false;
      }

      const response = await Post(`printDailyReport`, {
        shift_id: shiftId,
      });

      if (response && response.data) {
        console.log(response.data);
        localStorage.setItem("printDailyReport", JSON.stringify(response.data));
        return true;
      } else {
        console.error("Invalid response format:", response);
        handleToast({
          type: "ERROR",
          message: `Invalid response format: ${response}`
        });
        return false;
      }
    } catch (error) {
      console.error("Error in printDailyReport:", {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
      });

      if (error.response?.status === 400) {
        console.error(
          "Bad Request: The server could not process the request. Check shift_id validity."
        );

        handleToast({
          type: "ERROR",
          message: "Unable to generate report. Please try again later."
        });
      }
      return false;
    }
  };

 const handlePrintReport = async () => {
  const success = await printDailyReport(shiftId);
  if (success) {
    window.open('/report-preview', '_blank');
  }
};


  return (
    <button

      onClick={handlePrintReport}
      className="menu-option"
    // style={{
    //       backgroundColor: "#fff",
    //       color: "green",
    //       border: "none",
    //       padding: "8px 16px",
    //       borderRadius: "4px",
    //       cursor: "pointer",
    //       fontWeight: "bold",
    //       width:'fit-content',
    //       height:"40px"
    //     }}
    >
      <FileText size={20} />
      <span>  Get Report</span>
      <ArrowRight size={16} />
    </button>
  );
};

export default PrintReport;